module.exports = "button{ margin-left:0px;}"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/login/login.component.css
// module id = ./src/app/core/components/login/login.component.css
// module chunks = main